import { Injectable } from '@angular/core';
import { Badge } from '@shared-libs/classes';
import { Observable } from 'rxjs';
import { BadgeProvider } from '@shared-providers/api/badge.provider';

/**
 * The service that handles the badges
 *
 * Should be ran on webworker instead of main thread.
 */
@Injectable({
	providedIn: 'root',
})
export class BadgeService {
	public releaseNotesBadge: Badge;

	constructor(private readonly provider: BadgeProvider) {}

	public getReleaseNotesBadge(): Observable<number> {
		if (!this.releaseNotesBadge) {
			this.releaseNotesBadge = new Badge(this.provider.getReleaseNotes());
		}
		return this.releaseNotesBadge.getObservable();
	}
	/**
	 * Destroy the BadgeService and individual badges
	 */
	public destroy(): void {
		this.releaseNotesBadge?.destroy();
		this.releaseNotesBadge = null;
	}
}
